<ng-container *ngIf="toasters">
  <motif-toast class="toaster-ct"
               position="fixed"
               placement="top"
               *ngFor="let toaster of toasters"
               [type]="toaster.type"
               [show]="true"
               [duration]="toaster.duration || duration"
               (hidden)="removeToaster(toaster)">
    {{toaster.message}}
  </motif-toast>
</ng-container>
